// extracted by mini-css-extract-plugin
export default {"info-box":"Home_info-box__jMcSD","card":"Home_card__7C0wR","card1":"Home_card1__IX1Ks","card2":"Home_card2__xu9eP","card3":"Home_card3__2iowg"};